<template>
  <div class="ticketNewCrudComp">

    <div>
      <label class="label_title" for="">Кресло</label>
      <input
          placeholder="Введите ID кресла или адрес"
          type="text"
          v-model="kontroller"
          :class="['input_grey', {'animated shake error_input': errors.kontroller}]"
          @click="resetError('kontroller')"
      >
      <p class="p_err_min">{{ errors.kontroller }}</p>
    </div>

    <div>
      <label class="label_title" for="">Номер телефона пользователя</label>
      <input
          v-mask="$helpers.input.masks.phone"
          placeholder=""
          type="text"
          v-model="userPhone"
          :class="['input_grey', {'animated shake error_input': errors.userPhone}]"
          @click="resetError('userPhone')"
      >
      <p class="p_err_min">{{ errors.userPhone }}</p>
    </div>

    <div>
      <label class="label_title" for="">Комментарий</label>
      <input
          type="text"
          v-model="comment"
          :class="['input_grey']"
      >
    </div>

    <div>
      <h3>Проблемы</h3>
    </div>
    <div>
      <div class="div_check" v-for="(problem, index) in problems" :key="index">
        <input type="checkbox" :id="`check_${index}`" v-model="problems[index].check">
        <label :for="`check_${index}`" class="check_title">{{ problem.name }}</label>
      </div>
    </div>

    <div class="div_btns">
      <button-comp :classBtn="'btn_orange_min'" :textBtn="'Сохранить'" :clickBtn="save"/>
      <button-comp :classBtn="'btn_orange_min'" :textBtn="'Назад'" :clickBtn="toAll"/>
    </div>

    <p class="p_err_main">{{ errMain }}</p>

  </div>
</template>

<script>
export default {
  name: 'ticketNewCrudComp',
  props: {},
  data: function () {
    return {
      required: null,
      moduleName: 'tickets',
      users: {
        moduleName: 'users'
      },
      moduleProblems: {
        moduleName: 'problems'
      },
      kontroller: '',
      userPhone: '',
      comment: ''
    }
  },
  beforeCreate () {
  },
  beforeCreate: function () {
  },
  created: function () {
    this.$store.dispatch(`${this.moduleName}/getProblems`, {})
  },
  watch: {},
  components: {},
  computed: {
    errMain: function () {
      return this.$store.getters[`${this.moduleName}/getErrMain`]
    },
    errors: function () {
      return this.$store.getters[`${this.moduleName}/getErrors`]
    },
    role: function () {
      return localStorage.getItem('role')
    },
    problems: function () {
      return this.$store.getters[`${this.moduleName}/getProblems`]
    }
  },
  methods: {
    save () {
      this.userPhone = this.userPhone.replace(/[()_-]/g, '')
      let problems = []
      this.problems.forEach(problem => {
        if (problem.check) problems.push(problem.id)
      })
      this.$store.dispatch(`${this.moduleName}/add`, {
        userPhone: this.userPhone,
        kontroller: this.kontroller,
        comment: this.comment,
        problems: problems
      })
    },
    toAll () {
      this.$store.dispatch(`${this.moduleName}/toAll`)
    },
    resetError (param) {
      this.$store.commit(`${this.moduleName}/setErrors`, { param: param, value: null })
    }
  }
}
</script>

<style scoped lang="scss">

.ticketNewCrudComp {
  width: 350px;
  margin: 32px auto 32px auto;
}

.div_btns {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 32px;
  margin-top: 32px;
}

.div_check {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 60px 1fr;
  margin-bottom: 20px;
}

.div_check input {
  margin: auto 10px auto auto;
}

.div_check label {
  margin: auto;
}

@media screen and (max-width: 1140px) {
}

@media screen and (max-width: 960px) {
}

@media screen and (max-width: 720px) {
}

@media screen and (max-width: 540px) {
}

@media screen and (max-width: 480px) {
  .ticketNewCrudComp {
    width: calc(100% - 32px);
  }
}

@media screen and (max-width: 320px) {
}

</style>
